export default __webpack_public_path__ + "static/media/Freebooter's Girdle of the Untamed.5ed89c21.jpg";